import { render } from "./DetailPageButtons.vue?vue&type=template&id=05ccf6c9&scoped=true"
import script from "./DetailPageButtons.vue?vue&type=script&lang=ts"
export * from "./DetailPageButtons.vue?vue&type=script&lang=ts"

import "./DetailPageButtons.vue?vue&type=style&index=0&id=05ccf6c9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-05ccf6c9"

export default script